// extracted by mini-css-extract-plugin
module.exports = {"station-strategy":"StationStrategy_station-strategy__3QVF8"};